/**
 * Copy for the pro-rata confirmation shown when a quota's current target is
 * changed while supplier-level distribution has been manually edited. Ported
 * from the legacy Supplier CT update warning modal. Structurally compatible
 * with core-overlay's ProRataConfirmationDrawerData.
 */
export const QUOTA_PRO_RATA_CONFIRMATION = {
  title: 'Update Current Target',
  subtitle: 'Supplier Level Quota enabled',
  message:
    'This project has <strong>Supplier Level Quota</strong> enabled, this means that you have manually edited the supplier distribution on this quota.<br /><br />The adjustment you are about to make will result in a <strong>pro-rata distribution</strong>. This means that the adjustment will be applied on a pro-rata basis for the respective quota(s) and/or supplier distributions below this Goal Amount.',
  confirmLabel: 'CONTINUE',
  cancelLabel: 'CANCEL',
  advanced: {
    triggerLabel: 'Advanced…',
    sectionTitle: 'Advanced Options',
    sectionMessage:
      '<strong>LEAVE AS IS:</strong> Selecting this will keep your edited target, quotas and/or suppliers at their fixed value and will distribute the new number across rest of the suppliers.',
    confirmLabel: 'CONTINUE with LEAVE AS-IS',
    tooltip:
      'Advanced Options include:\nLEAVE AS IS:\nSelecting this will keep your edited target, quotas and/or suppliers at their fixed value and will distribute the new number across rest of the suppliers.',
  },
} as const;
